export const CARD_REPORT = {
  "Cardreport.Space.Around": {
    defaultValue: "default"
  },
  "Cardreport.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Cardreport.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Cardreport.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Cardreport.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Cardreport.Height.Type": {
    defaultValue: "fixed"
  },

  "Cardreport.Width": {
    defaultValue: "250px"
  },
  "Cardreport.Min.Width": {
    defaultValue: "none"
  },
  "Cardreport.Max.Width": {
    defaultValue: "none"
  },
  "Cardreport.Height": {
    defaultValue: "auto"
  },
  "Cardreport.Min.Height": {
    defaultValue: "none"
  },
  "Cardreport.Max.Height": {
    defaultValue: "none"
  },

  "Cardreport.Margin.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Margin.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Margin.Left": {
    defaultValue: "0px"
  },

  "Cardreport.Hover.Shadow.Type": {
    defaultValue: "none"
  },
  "Cardreport.Hover.Shadow.Color": {
    defaultValue: "Color.Transparent"
  },
  "Cardreport.Shadow.Type": {
    defaultValue: "none"
  },
  "Cardreport.Shadow.Color": {
    defaultValue: "Color.Transparent"
  },
  "Cardreport.Hover.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Hover.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Hover.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Hover.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Hover.Border.Color": {
    ref: "Color.Gray.300"
  },
  "Cardreport.Hover.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Cardreport.Border.Color": {
    ref: "Color.Gray.300"
  },
  "Cardreport.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Cardreport.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Cardreport.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Cardreport.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Cardreport.Border.Style": {
    defaultValue: "solid"
  },
  "Cardreport.Content.Align.Horizontal": {
    defaultValue: "flex-start"
  },
  "Cardreport.Content.Font.Align": {
    defaultValue: "left"
  },
  "Cardreport.Content.Align.Vertical": {
    defaultValue: "center"
  },
  "Cardreport.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Cardreport.Padding.Left": {
    defaultValue: "12px"
  },
  "Cardreport.Padding.Right": {
    defaultValue: "12px"
  },
  "Cardreport.Padding.Top": {
    defaultValue: "12px"
  },
  "Cardreport.Padding.Bottom": {
    defaultValue: "12px"
  }
};
